const validateInfo = (info) => {
  let errors = [];
  if (info.password1 !== info.password2) errors.push("Passwords do not match");
  return errors;
};
export default validateInfo;
